// ============================================================
// VCS.I18n — Sprache & Übersetzungen
// ============================================================
window.VCS = window.VCS || {};

VCS.I18n = class {

    // ── Konstruktor ──────────────────────────────────────────

    constructor() {
        // View-Cache
        this._view = {
            btnLang:           $('#btnLang'),
            regLangSelect:     $('#regLangSelect'),
            settingsLangSelect:$('#settingsLangSelect'),
        };
    }

    // ── Öffentliche Methoden ─────────────────────────────────

    // Übersetzungs-Lookup
    t(key) {
        const lang = VCS.state.currentLang;
        return TRANSLATIONS[lang]?.[key] || TRANSLATIONS['de']?.[key] || key;
    }

    // Sprache setzen, speichern und anwenden
    async setLang(lang) {
        if (!AVAILABLE_LANGS.includes(lang)) {
            return;
        }
        VCS.state.currentLang = lang;
        localStorage.setItem('call-lang', lang);

        // Sprachdatei lazy nachladen, falls noch nicht im Cache
        if (!TRANSLATIONS[lang]) {
            await loadLanguage(lang);
        }

        this.applyLang();

        // Cross-Modul-Aktionen (null-safe, Module ggf. noch nicht initialisiert)
        VCS.captions?.sendConfig?.();
        VCS.chat?.updateLangOnBackend?.();
        VCS.chatMessages?.resetEmojiPicker?.();
        VCS.chatMessages?._updateCacheSize?.();
    }

    // Zur nächsten Sprache wechseln (zyklisch)
    toggleLang() {
        const idx = AVAILABLE_LANGS.indexOf(VCS.state.currentLang);
        this.setLang(AVAILABLE_LANGS[(idx + 1) % AVAILABLE_LANGS.length]);
    }

    // DOM mit aktueller Sprache befüllen
    applyLang() {
        const lang = VCS.state.currentLang;
        document.documentElement.lang = lang;

        $('[data-i18n]').each(function() {
            $(this).html(t($(this).data('i18n')));
        });

        $('[data-i18n-placeholder]').each(function() {
            $(this).attr('placeholder', t($(this).data('i18n-placeholder')));
        });

        // Aria-Label / aria-valuetext from i18n keys (e.g. audio-fader).
        // Additive: only elements with the data attribute get touched.
        $('[data-i18n-aria-label]').each(function() {
            $(this).attr('aria-label', t($(this).data('i18n-aria-label')));
        });
        $('[data-i18n-aria-valuetext]').each(function() {
            $(this).attr('aria-valuetext', t($(this).data('i18n-aria-valuetext')));
        });

        this._view.btnLang.text(lang.toUpperCase());
        this._view.regLangSelect.val(lang);
        this._view.settingsLangSelect.val(lang);

        // Cross-Modul-UI-Updates (null-safe)
        VCS.ui?.updateRingToggleUI?.();
        VCS.ui?.updateBlurButtonUI?.();
        VCS.ui?.updateNotifyButtonUI?.();
        VCS.ui?.applyTooltips?.();
        VCS.netStats?.resetText?.();
        VCS.callControls?.updateApprovalCallType?.();
        VCS.callControls?.updatePreStatusLabel?.();
        VCS.chat?.updateRegistrationUI?.();
        VCS.chatRecordingUI?.updateRecordButtonUI?.();
        VCS.chatRecordingUI?.updateRecordingBarMode?.();
        VCS.chatSetup?.updateSettingsUI?.();
        // Dating-Views werden per Template gerendert, nicht ueber data-i18n —
        // die Schleife oben erreicht sie nicht.
        VCS.datingProfile?.onLangChange?.();
        VCS.datingDeck?.onLangChange?.();
        VCS.datingRadar?.onLangChange?.();
        VCS.dating?.onLangChange?.();
    }

    // Sprach-Code normalisieren (für Deepgram / Caption-Config)
    // z.B. "de-DE" → "de", "EN" → "en"
    normalizeLang(lang) {
        if (typeof lang !== 'string') {
            return '';
        }
        const normalized = lang.trim().toLowerCase().replace(/_/g, '-');
        if (!normalized) {
            return '';
        }
        const primary = normalized.split('-')[0];
        if (!/^[a-z]{2,3}$/.test(primary)) {
            return '';
        }
        return primary;
    }

    // Prüft ob eine Sprache für Übersetzung unterstützt wird
    isTranslationSupported(lang) {
        return typeof lang === 'string' && lang.length > 0;
    }

    // Browser-Sprache ermitteln (Fallback: 'de')
    detectLang() {
        const prefix = (navigator.language || '').toLowerCase().slice(0, 2);
        return AVAILABLE_LANGS.includes(prefix) ? prefix : DEFAULT_LANG;
    }

    // ── Init ─────────────────────────────────────────────────

    init() {
        this.applyLang();
        this._view.btnLang.on('click', () => this.toggleLang());
    }
};
